// extracted by mini-css-extract-plugin
export default {"root":"TopLogo_root__3hkWI","nameContainer":"TopLogo_nameContainer__Kj-BD","collapsed":"TopLogo_collapsed__4e82P"};